import {
  type Key,
  type PropsWithChildren,
  createContext,
  useMemo,
} from "react";

import type { AccordionItemValue } from "./AccordionItemContext.decl";

export const AccordionItemContext =
  createContext<AccordionItemValue<any> | null>(null);

export function AccordionItemProvider<ItemId extends Key>({
  children,
  isOpened,
  id,
}: PropsWithChildren<AccordionItemValue<ItemId>>) {
  const value = useMemo<AccordionItemValue<ItemId>>(
    () => ({
      isOpened,
      id,
    }),
    [isOpened, id]
  );

  return (
    <AccordionItemContext.Provider value={value}>
      {children}
    </AccordionItemContext.Provider>
  );
}
